import { useEffect, useRef, useState } from "react";
import TransferSelect from "src/components/common/transferSelect";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import UserInfo from "src/components/common/userInfo";
import CurrentMaterialCost from "src/components/common/currentMaterialCost";
import { useMyStore } from "src/components/main/mainStore";
import {
    myAxios, 
    MyFormData, 

    getDatefromWeekNum, 
    mimeTypeMap, 
    numberReducer, 
    scroll, 
    isDevMode, 
} from "src/components/common/functions";
import BillingForm from "./billingForm";
//--------------------------------------------------------------------------------------------
export default function Detail({    
    updateDateTime, 
    curWeekStart, 
    curWeekEnd, 
    deleteBilling, 
    restoreBilling, 
    notify, 
    editBilling, 
    users, 
    usersMap, 
    projects, 
    billing, 
    history, 
    path1, 
    path2, 
    path3, 
    setShowLoader, 
    user, 
    setBillings, 
}){
    //--------------------------------------------------------------------------------------------
    const allWorkLogs = useMyStore(state => state.billingWorkLogs);
    const setWorkLogs = useMyStore(state => state.setBillingWorkLogs);
    const workLogs = allWorkLogs[billing.projectHashKey] ?? [];
    //--------------------------------------------------------------------------------------------
    const receiptUploadRef = useRef(null);
    //--------------------------------------------------------------------------------------------
    const statusIcon = e => {
        switch(e){
            case "Approved":
                return <span style = {{color: "green"}}>✓</span>;
            case "Reject":
                return <span style = {{color: "red"}}>✘</span>;
            default: 
        }
    }
    //--------------------------------------------------------------------------------------------
    const [comments, setComments] = useState(billing.approverNotes || "");
    const [showTransferSelect, setShowTransferSelect] = useState(false);
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(path2 === "" || (allWorkLogs[billing.projectHashKey] && updateDateTime["Work Logs"] === allWorkLogs.updatedAt)) return; 
        let isMounted = true;
        const controller = new AbortController();
        const getData = async() => {
            if(isDevMode) console.log("useEffect detail");
            const formData = new MyFormData();
            formData.append("projectHashKey", billing.projectHashKey);
            //-------------------------------------------------
            setShowLoader(true);
            const resWorkLogs = await myAxios("billings/readBillingAllWorkLogs.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoader(false);
            if(!resWorkLogs) return;
            //-------------------------------------------------
            setWorkLogs(
                billing.projectHashKey, 
                resWorkLogs.data, 
                updateDateTime["Work Logs"]
            );
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
            setShowLoader(false);
        }
    }, [path2, updateDateTime, allWorkLogs, billing.projectHashKey, setShowLoader, setWorkLogs])
    //--------------------------------------------------------------------------------------------
    return(
        
    <div className = "border" style = {{borderRadius: "6px"}}>
        <form>
            <fieldset className = "border rounded p-2" style = {{minWidth: "800px", maxWidth: "90%", margin: "20px auto", whiteSpace: "pre-wrap"}}>
                <legend style = {{width: "auto", padding:"0px 10px"}}>Notes</legend>
                {billing.notes}
            </fieldset>
        </form>
        <div className = "table-responsive" style = {{minWidth: "800px",maxWidth: "90%", margin: "20px auto"}}>
        <table className = "table">
            <colgroup>
                <col/>
            </colgroup>
            <tbody>
                <tr>
                    <th></th>
                    {JSON.parse(billing.approval).map((approval, approvalIndex) =>
                    <th key = {approvalIndex}>Level {approvalIndex + 1} {statusIcon(approval.approverDecision)}</th>
                    )}
                </tr>
                <tr>
                    <th>Approver</th>
                    {JSON.parse(billing.approval).map((approval, approvalIndex) =>
                    <td key = {approvalIndex}>
                        {approval.approverEmail?
                        <span style = {{color: "blue", cursor: "pointer"}}>
                            <UserInfo 
                            name = {usersMap[approval.approverEmail]}
                            email = {approval.approverEmail}
                            />
                        </span>
                        :approval.candidateEmail.length === 1?
                        <span style = {{color: "blue", cursor: "pointer"}}>
                            <UserInfo 
                            name = {usersMap[approval.candidateEmail[0]]}
                            email = {approval.candidateEmail[0]}
                            />
                        </span>
                        :
                        <span>
                            one of the following:
                            {approval.candidateEmail.map((candidateEmailItem, candidateEmailItemIndex) => 
                                <li key = {candidateEmailItemIndex}>
                                    <UserInfo 
                                        name = {usersMap[candidateEmailItem]}
                                        email = {candidateEmailItem}
                                    />
                                </li>)}
                        </span>
                        }
                    </td>
                    )}
                </tr>
                <tr>
                    <th>Review Time</th>
                    {JSON.parse(billing.approval).map((approvalIndex, key) =>
                    <td key = {key}>
                        {approvalIndex.reviewTime ?? ""}
                    </td>
                    )}
                </tr>
                <tr>
                    <th>Review Decision</th>
                    {JSON.parse(billing.approval).map((approval, key) =>
                    <td key = {key}>
                        {approval.approverDecision}
                    </td>
                    )}
                </tr>
                <tr>
                    <th>Approver Comments</th>
                    {JSON.parse(billing.approval).map((approval, key) =>
                    <td key = {key} style = {{whiteSpace: "pre-wrap"}}>
                        {approval.approverNotes}
                    </td>
                    )}
            </tr>
            </tbody>
        </table>
        </div>
        <CurrentMaterialCost
            updateDateTime = {updateDateTime}
            projectHashKey = {billing.projectHashKey ?? ""}
            projectName = {billing.projectName ?? ""}
        />
        <details className = "my-4 mx-5">
            <summary>Job Tags</summary>
            <div className = "table-responsive mt-2">
            <table className = "table">
                <thead>
                    <tr>
                        <th>Duration</th>
                        <th>Technician</th>
                        <th>Job Tag</th>
                        <th>Travel Start Time</th>
                        <th>Work Start Time</th>
                        <th>Workr End Time</th>
                        <th>Travel End Time</th>
                        <th>Total Hours</th>
                    </tr>
                </thead>
                <tbody>
                {workLogs.map((wL, wLIndex) => <tr key = {wLIndex}>
                    <td>
                    <strong>
                        <span style = {{fontSize: 20}}>{wL.startTime.substring(0, 10)}</span>
                        {
                            wL.startTime.substring(11, 16) === "00:00" && wL.endTime.substring(11, 16) === "00:00"?
                            ``
                            :
                            ` ${wL.startTime.substring(11, 16)}`
                        }
                        {
                            wL.startTime.substring(0, 10) === wL.endTime.substring(0, 10) && wL.startTime.substring(11, 16) === "00:00" && wL.endTime.substring(11, 16) === "00:00"?
                            ``
                            :
                            ` ~ `
                        }
                        {
                            wL.startTime.substring(0, 10) === wL.endTime.substring(0, 10)?
                                wL.startTime.substring(11, 16) === "00:00" && wL.endTime.substring(11, 16) === "00:00"?
                                ``
                                :
                                wL.endTime.substring(11, 16)
                            :
                                wL.startTime.substring(11, 16) === "00:00" && wL.endTime.substring(11, 16) === "00:00"?
                                <span style = {{fontSize: 20}}>{wL.endTime.substring(0, 10)}</span>
                                :
                                <>
                                    <span style = {{fontSize: 20}}>{wL.endTime.substring(0, 10)} </span>
                                    {wL.endTime.substring(11, 16)}
                                </>
                        }
                    </strong>
                    </td>
                    <td><UserInfo 
                        name = {wL.laborName}
                        email = {wL.labor}
                    /></td>
                    <td>
                        <button type = "button" className = "btn btn-primary" onClick = {async() => {
                            const formData = new MyFormData();
                            formData.append("fileId[]", wL.jobTag);
                            const duration = wL.startTime.substring(0, 10) === wL.endTime.substring(0, 10)?wL.startTime.substring(0, 10):`from ${wL.startTime.substring(0, 10)} to ${wL.endTime.substring(0, 10)}`;
                            formData.append("fileName[]", `${wL.laborName} ${duration}.pdf`);
                            //-------------------------------------------------
                            setShowLoader(true);
                            const res = await myAxios("common/getFile.php", formData, "blob");
                            setShowLoader(false);
                            if(!res) return;
                            //-------------------------------------------------
                            saveAs(new Blob([res.data]), `${wL.laborName} ${duration}.pdf`);                            
                        }}>
                            Download
                        </button>
                    </td>
                    <td>{wL.travelStartTime}</td>
                    <td>{wL.workStartTime}</td>
                    <td>{wL.workEndTime}</td>
                    <td>{wL.travelEndTime}</td>
                    <td>
                        <li>Travel: {((
                            (new Date(wL.workStartTime.replace(/-/, "/")) - new Date(wL.travelStartTime.replace(/-/, "/")))
                            + 
                            (new Date(wL.travelEndTime.replace(/-/, "/")) - new Date(wL.workEndTime.replace(/-/, "/")))
                            ) / 3600000).toFixed(2)}</li>
                        <li>Work: {((new Date(wL.workEndTime.replace(/-/, "/")) - new Date(wL.workStartTime.replace(/-/, "/"))) / 3600000).toFixed(2)}</li>
                        <li>Total: {((new Date(wL.travelEndTime.replace(/-/, "/")) - new Date(wL.travelStartTime.replace(/-/, "/"))) / 3600000).toFixed(2)}</li>
                    </td>
                </tr>)}
                    <tr>
                        <td style = {{borderTop:"none"}}></td>
                        <td style = {{borderTop:"none"}}></td>
                        <td style = {{borderTop:"none"}}></td>
                        <td style = {{borderTop:"none"}}></td>
                        <td style = {{borderTop:"none"}}></td>
                        <td style = {{borderTop:"none"}}></td>
                        <td style = {{textAlign: "right"}}><strong>Total:</strong></td>
                        <td>
                            <li>Travel: {(workLogs.map(wL => (
                                (new Date(wL.workStartTime.replace(/-/, "/")) - new Date(wL.travelStartTime.replace(/-/, "/")))
                                + 
                                (new Date(wL.travelEndTime.replace(/-/, "/")) - new Date(wL.workEndTime.replace(/-/, "/")))
                                ) / 3600000).reduce(numberReducer, 0)).toFixed(2)}</li>
                            <li>Work: {(workLogs.map(wL => (new Date(wL.workEndTime.replace(/-/, "/")) - new Date(wL.workStartTime.replace(/-/, "/"))) / 3600000).reduce(numberReducer, 0)).toFixed(2)}</li>
                            <li>Total: {(workLogs.map(wL => (new Date(wL.travelEndTime.replace(/-/, "/")) - new Date(wL.travelStartTime.replace(/-/, "/"))) / 3600000).reduce(numberReducer, 0)).toFixed(2)}</li>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
        </details>
        <input
            type = "file"
            accept = {mimeTypeMap.pdf}
            ref = {receiptUploadRef}
            style = {{display:"none"}}
            onChange = {async e => {
                const target = e.currentTarget;
                const files = target.files;
                if(files.length === 1){
                    const formData = new MyFormData();
                    formData.append("billingNumber", billing.billingNumber);
                    formData.append("pdf", files[0]);
                    formData.append("start", getDatefromWeekNum(curWeekStart, 0));
                    formData.append("end", getDatefromWeekNum(curWeekEnd, 7));
                    const fileName = files[0].name;
                    const fn = fileName.toLowerCase().split(".");
                    if(fn[fn.length - 1] !== "pdf"){
                        window.alert("Please select PDF only.");
                        return;
                    }
                    //-------------------------------------------------
                    setShowLoader(true);
                    const res = await myAxios("billings/addPDF.php", formData);
                    setShowLoader(false);
                    if(!res) return;
                    //-------------------------------------------------
                    setBillings(curWeekStart, curWeekEnd, res.data);
                    history.replace(`/${path1}`);
                    scroll(null);
                }
                target.value = "";
            }}
        />
        {!billing.void?<>
        <div className = "m-3 text-right">
            {billing.decision !== "Submitted" || 
            (!JSON.parse(billing.approval).every(uu => 
                uu.approverDecision === "Approved"
            ) && JSON.parse(billing.approval).filter(uu => 
                uu.approverDecision !== "Approved"
            )[0].candidateEmail.includes(user.email))?<></>:
            <button type = "button" className = "btn btn-success m-3" onClick = {notify} id = {billing.billingNumber}>Notify Approver</button>
            }
            <button type = "button" className = "btn btn-info m-3" onClick = {() => {receiptUploadRef.current.click();}}>Update PDF</button>
            <button type = "button" className = "btn btn-success m-3" onClick = {editBilling} id = {billing.billingNumber}>Edit Bill</button>
            <button type = "button" className = "btn btn-danger m-3" onClick = {deleteBilling} id = {billing.billingNumber}>Void Bill</button>
        </div>
        {billing.notify?
        <div className = "m-3 text-right">
            Notified At {billing.notify}
        </div>
        :<></>}
        </>:<></>}
        {
        JSON.parse(billing.approval).find(approvalLevel => approvalLevel.candidateEmail.includes(user.email)) &&
        !JSON.parse(billing.approval).find(approvalLevel => approvalLevel.candidateEmail.includes(user.email)).approverEmail
        ?(!billing.void?
        <div className = "mb-4">
            <div>
                <button type = "button" className = "btn btn-warning m-3" onClick = {() => {
                    setShowTransferSelect(true);
                }}>Forward Approval</button>
            </div>
            {showTransferSelect?
            <TransferSelect
                users = {users}
                closeIt = {() => setShowTransferSelect(false)}
                handleSubmit = {async e => {
                    e.preventDefault();
                    const formData = new MyFormData(e.currentTarget);
                    const forward = JSON.parse(formData.get("forward"));
                    if(!forward.email){
                        window.alert("Select an approver first.");
                        return;
                    }
                    formData.append("billingNumber", billing.billingNumber);
                    formData.append("forwardEmail", forward.email);
                    formData.append("start", getDatefromWeekNum(curWeekStart, 0));
                    formData.append("end", getDatefromWeekNum(curWeekEnd, 7));
                    //-------------------------------------------------
                    setShowLoader(true);
                    const res = await myAxios("billings/forward.php", formData);
                    setShowLoader(false);
                    if(!res) return;
                    //-------------------------------------------------
                    history.push(`/${path1}`);
                    setBillings(curWeekStart, curWeekEnd, res.data);
                    setShowTransferSelect(false);
                }}
            />
            :<></>}
            <div className = "mx-3">
                <label htmlFor = "approvalNotes" className = "font-weight-bold mb-0">Approval Comments:</label>
                <textarea id = "approvalNotes" className = "form-control" value = {comments} onChange = {e => {setComments(e.currentTarget.value)}} name = "comments"/>
            </div>
            <div>
                {[
                    {title:"Approve", decision:"Approved", word: "approve", color: "btn-success"}, 
                    {title:"Reject", decision:"Rejected", word: "reject", color: "btn-danger"}
                ].map((item, itemIndex) => 
                <button type = "button" key = {itemIndex} className = {`btn ${item.color} mx-3 mt-3`} onClick = {async() => {
                    if(item.word === "reject" && !comments){
                        window.alert("Comments are required for rejection.");
                        return;
                    }
                    if(!window.confirm(`Are you sure to ${item.word} this billing?`)) return;
                    const formData = new MyFormData();
                    formData.append("billingNumber", billing.billingNumber);
                    formData.append("approverDecision", item.decision);
                    formData.append("approverNotes", comments);
                    formData.append("start", getDatefromWeekNum(curWeekStart, 0));
                    formData.append("end", getDatefromWeekNum(curWeekEnd, 7));
                    //-------------------------------------------------
                    setShowLoader(true);
                    const res = await myAxios("billings/approval.php", formData);
                    setShowLoader(false);
                    if(!res) return;
                    //-------------------------------------------------
                    setBillings(curWeekStart, curWeekEnd, res.data);
                }}>{item.title}</button>)}
            </div>
        </div>
        :<>
        <div className = "m-4 font-weight-bold h3">Void</div>
        <div className = "m-4"><span className = "h4 mr-3">Void Reason:</span>{billing.voidReason}</div>
        <div className = "m-4"><button type = "button" className = "btn btn-danger" onClick = {restoreBilling} id = {billing.billingNumber}>Valid</button></div>
        </>
        ):<></>
        }
        {path3 === "Edit"?
        <BillingForm
            keyword = "Update"
            closeIt = {() => {
                history.push(`/${path1}/${path2}`);
            }}
            updateDateTime = {updateDateTime}
            curWeekStart = {curWeekStart}
            curWeekEnd = {curWeekEnd}
            users = {users}
            projects = {projects}
            {...billing}
        />
        :<></>}
    </div>
    )
}